import { AccountBalance, Link as LinkIcon, LinkOff } from '@mui/icons-material';
import {
  Button,
  Paper,
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { BankConnection, BankConnectionStatus } from '../../api/gql';

type Props = {
  bankConnections?: BankConnection[];
};

export const BankConnections = ({ bankConnections }: Props) => {
  const { t } = useTranslation('bank-connection');

  return (
    <TableContainer component={Paper}>
      <MUITable>
        <TableHead>
          <TableRow>
            <TableCell width={64}></TableCell>
            <TableCell>{t('table.bank')}</TableCell>
            <TableCell align="right">{t('table.status')}</TableCell>
            <TableCell align="right"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {bankConnections?.map((bankConnection) => (
            <TableRow key={bankConnection.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th">
                {bankConnection.bankLogoUrl ? (
                  <img
                    src={bankConnection.bankLogoUrl}
                    alt={`${bankConnection.bankName} logo`}
                    height={64}
                    width={64}
                  />
                ) : (
                  <AccountBalance sx={{ fontSize: 64 }} />
                )}
              </TableCell>
              <TableCell component="th" scope="row">
                {bankConnection.bankName}
              </TableCell>
              <TableCell align="right">
                <Typography
                  fontWeight={'bold'}
                  color={bankConnection.status === BankConnectionStatus.Valid ? 'success.main' : 'warning.main'}
                >
                  {bankConnection.status === BankConnectionStatus.Valid ? t('table.valid') : t('table.expired')}
                </Typography>
              </TableCell>
              <TableCell align="right">
                {bankConnection.status === BankConnectionStatus.Valid ? (
                  <Button
                    startIcon={<LinkOff />}
                    variant={'outlined'}
                    component={Link}
                    to={`/bank-connection/disconnect/${bankConnection.id}`}
                  >
                    {t('table.disconnect')}
                  </Button>
                ) : (
                  <Button
                    startIcon={<LinkIcon />}
                    variant={'outlined'}
                    component={Link}
                    to={`/bank-connection/connect/${bankConnection.provider}`}
                  >
                    {t('table.connect')}
                  </Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </MUITable>
    </TableContainer>
  );
};
